import { render } from "./MobileFooter.vue?vue&type=template&id=e743cfb8&scoped=true&ts=true"
import script from "./MobileFooter.vue?vue&type=script&lang=ts"
export * from "./MobileFooter.vue?vue&type=script&lang=ts"

import "./MobileFooter.vue?vue&type=style&index=0&id=e743cfb8&scoped=true&lang=css"
import "./MobileFooter.vue?vue&type=style&index=1&id=e743cfb8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e743cfb8"]])

export default __exports__